import 'css-chunk:../authentication/frontend/components/error-printer/index.module.scss';export default {
  "error": "_error_16m7h_1"
};